interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "RUB";
};

const RUB: Currency = Object.freeze({
  "displayName": "Russian Ruble",
  "numericCode": 643,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "RUB",
  "symbol": "₽"
});

export { RUB };
